import { useCallback, useState } from "react";
import { getZendeskKey, isZendeskEnabled } from "./zendesk";
import { isTacticAppWebView } from "./isTacticAppWebView";

export function useZendeskChat() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const loadZendeskSnippet = useCallback(() => {
    const isMobile = isTacticAppWebView();
    if (isMobile || isLoaded || isLoading || !isZendeskEnabled()) {
      return;
    }

    setIsLoading(true);

    // Check if script already exists
    const existingScript = document.getElementById("ze-snippet");
    if (existingScript) {
      setIsLoaded(true);
      setIsLoading(false);
      return;
    }

    const scriptUrl = `https://static.zdassets.com/ekr/snippet.js?key=${getZendeskKey()}`;
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;
    script.id = "ze-snippet";

    script.onload = () => {
      window.zE?.("messenger", "hide");
      setIsLoaded(true);
      setIsLoading(false);
    };

    script.onerror = () => {
      setIsLoading(false);
    };

    document.body.appendChild(script);
  }, [isLoaded, isLoading]);

  const openChat = useCallback(() => {
    if (!isLoaded) {
      setShowLoader(true);
      loadZendeskSnippet();
      // Wait a bit for the script to load, then open chat
      setTimeout(() => {
        if (window.zE) {
          window.zE("messenger", "show");
          window.zE("messenger", "open");
          setShowLoader(false);
        }
      }, 2000);
    } else {
      if (window.zE) {
        window.zE("messenger", "show");
        window.zE("messenger", "open");
      }
    }
  }, [isLoaded, loadZendeskSnippet]);

  const hideChat = useCallback(() => {
    if (window.zE) {
      window.zE("messenger", "hide");
    }
  }, []);

  return {
    openChat,
    hideChat,
    showLoader,
    isEnabled: isZendeskEnabled()
  };
}
